// @flow
import { LANDING_BACKEND_URL } from "../../Constants/Global/apiConstants";
import axios from "axios";

export function fetchLandingPageLogos() {
  return axios.create({
    method: "get",
    url: `${LANDING_BACKEND_URL}/logos/landingpage/visible`
  });
}

export function fetchLandingPageTestimonials() {
  return axios.create({
    method: "get",
    url: `${LANDING_BACKEND_URL}/testimonials/landingpage/visible`
  });
}


// WEBPACK FOOTER //
// ./src/Api/PublicPages/landingpage.js